// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3xRPs","tab":"Tabs_tab__VI8s-","tabActive":"Tabs_tabActive__GUIN4"};